import { z } from 'zod';
import { PART_CONSTRAINTS } from './constraints.js';
import { partUrlSchema } from './part-url.js';
export const partIdentifiersEditFormSchema = z.object({
    upc: z
        .string()
        .trim()
        .max(PART_CONSTRAINTS.upc.maxLength)
        .regex(/^\d*$/, 'UPC must contain digits only.'),
    url: partUrlSchema,
    alertNote: z.string().trim().max(PART_CONSTRAINTS.alertNote.maxLength),
    abcCode: z
        .string()
        .trim()
        .transform((value) => value.toUpperCase())
        .refine((value) => value === '' || ['A', 'B', 'C'].includes(value), {
        message: 'ABC code must be A, B, or C.',
    }),
});
//# sourceMappingURL=identifiers-form.js.map